import React from "react";

const PrivacyAndPolicy = () => {
    return (
        <div className="account-pages my-5 pt-sm-5">
            <div className="container px-4 sm:px-6 md:px-8">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <div className="card overflow-hidden">
                            <div className="flex justify-center items-center min-h-screen bg-gray-100 p-6">
                                <div className="bg-white p-6 w-full max-w-2xl mx-auto rounded-lg shadow-lg">
                                    <h1 className="text-3xl font-bold mb-4 text-center">Privacy Policy</h1>
                                    <br></br>

                                    <div className="px-4 sm:px-6">
                                        <p className="text-gray-700">
                                            Thank you for using the <strong>Mercator Mobile App</strong> ("App"),
                                            operated by <strong>Mercator S.A.R.L</strong> ("Company," "we," "us," or "our").
                                            Your privacy is important to us, and this Privacy Policy explains how we collect,
                                            use, disclose, and protect your information when you use our App.
                                        </p>

                                        <hr className="my-6 border-gray-300" />

                                        <section>
                                            <h4 className="text-2xl font-semibold mb-2">1. Information We Collect</h4>

                                            <h5 className="text-xl font-semibold mt-4">a. Personal Information</h5>
                                            <p className="text-gray-700">We may collect personal information that you provide to us directly, such as:</p>
                                            <ul className="list-disc ml-6 text-gray-700">
                                                <li>Name</li>
                                                <li>Email address</li>
                                                <li>Phone number</li>
                                                <li>Company name</li>
                                                <li>Account login credentials</li>
                                            </ul>

                                            <h4 className="text-xl font-semibold mt-4">b. Usage and Device Information</h4>
                                            <p className="text-gray-700">
                                                We automatically collect certain information about your device and how you interact with the App, including:
                                            </p>
                                            <ul className="list-disc ml-6 text-gray-700">
                                                <li>Device type and operating system</li>
                                                <li>IP address</li>
                                                <li>App usage data and interactions</li>
                                            </ul>
                                        </section>

                                        <hr className="my-6 border-gray-300" />

                                        <section>
                                            <h4 className="text-2xl font-semibold mb-2">2. How We Use Your Information</h4>
                                            <p className="text-gray-700">We use the collected information for the following purposes:</p>
                                            <ul className="list-disc ml-6 text-gray-700">
                                                <li>To provide and improve the Apps functionality and user experience</li>
                                                <li>To process transactions and provide customer support</li>
                                                <li>To send important updates and notifications (with your consent)</li>
                                                <li>To monitor App usage, security, and performance</li>
                                                <li>To comply with legal and regulatory requirements</li>
                                            </ul>
                                        </section>

                                        <hr className="my-6 border-gray-300" />

                                        <section>
                                            <h4 className="text-2xl font-semibold mb-2">3. Data Security</h4>
                                            <p className="text-gray-700">
                                                We implement appropriate technical and organizational measures to protect your personal information.
                                                However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
                                            </p>
                                        </section>

                                        <hr className="my-6 border-gray-300" />

                                        <section>
                                            <h4 className="text-2xl font-semibold mb-2">4. Your Rights and Choices</h4>
                                            <ul className="list-disc ml-6 text-gray-700">
                                                <li><strong>Access and Correction:</strong> You can access and update your personal data in your account settings.</li>
                                                <li><strong>Delete Account:</strong> You may request account deletion by contacting us.</li>
                                            </ul>
                                        </section>

                                        <hr className="my-6 border-gray-300" />

                                        <section>
                                            <h4 className="text-2xl font-semibold mb-2">5. Childrens Privacy</h4>
                                            <p className="text-gray-700">
                                                The App is not intended for children under 13, and we do not knowingly collect data from minors.
                                                If we learn that we have collected such data, we will take appropriate steps to delete it.
                                            </p>
                                        </section>

                                        <hr className="my-6 border-gray-300" />

                                        <section>
                                            <h4 className="text-2xl font-semibold mb-2">6. Changes to This Privacy Policy</h4>
                                            <p className="text-gray-700">
                                                We may update this Privacy Policy from time to time. We will notify you of significant changes
                                                through the App or other means. Please review the policy periodically.
                                            </p>
                                        </section>

                                        <hr className="my-6 border-gray-300" />

                                        <section>
                                            <h4 className="text-2xl font-semibold mb-2">7. Contact Us</h4>
                                            <p className="text-gray-700">
                                                If you have any questions about this Privacy Policy or your personal data, you can contact us at:
                                            </p>
                                            <div className="bg-gray-100 p-4 rounded-lg mt-2">
                                                <p><strong>Mercator S.A.R.L</strong></p>
                                                <p>Beirut, Sin El Fil</p>
                                                <p>Email: <a href="mailto:support@mercatorapp.com" className="text-blue-500">support@mercatorapp.com</a></p>
                                                <p>Website: <a href="https://www.mercatorapp.com" className="text-blue-500" target="_blank" rel="noopener noreferrer">www.mercatorapp.com</a></p>
                                            </div>
                                        </section>

                                    </div>
                                    <hr className="my-6 border-gray-300" />

                                    <p className="text-center text-gray-700">
                                        By using the <strong>Mercator Mobile App</strong>, you agree to this Privacy Policy. If you do not agree, please do not use the App.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyAndPolicy;
